module.exports = __webpack_public_path__ + "img/moGaoKu3.4b3a0550.png";